import type React from 'react';

import cn from '../../../../utils/cn';

export interface PageBodyProps {
  children: React.ReactNode;
  className?: string;
}

const PageBody = ({ children, className }: PageBodyProps) => {
  return <div className={cn('flex flex-col', className)}>{children}</div>;
};

export default PageBody;
